import ScrollReveal from "../../../components/feature/ScrollReveal";
import { aboutData } from "../../../mocks/companyData";

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-14">
              <p className="section-label mb-3">{aboutData.label}</p>
              <h2 className="section-title">{aboutData.title}</h2>
              <p className="section-subtitle">{aboutData.subtitle}</p>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <div className="bg-white rounded-lg p-8 md:p-10">
              <dl className="grid grid-cols-1 sm:grid-cols-2 gap-y-5 gap-x-12">
                {aboutData.items.map((item) => (
                  <div key={item.label} className="flex flex-col border-b border-airdoa-gray-light/30 pb-4 last:border-0">
                    <dt className="text-xs text-airdoa-gray mb-1.5 tracking-wide">
                      {item.label}
                    </dt>
                    <dd className="text-sm font-medium text-airdoa-navy whitespace-pre-line">
                      {item.value}
                    </dd>
                  </div>
                ))}
                <div className="flex flex-col border-b border-airdoa-gray-light/30 pb-4 last:border-0">
                  <dt className="text-xs text-airdoa-gray mb-1.5 tracking-wide">
                    事業内容
                  </dt>
                  <dd className="text-sm text-airdoa-navy">
                    <ul className="flex flex-col gap-1.5">
                      {aboutData.business.items.map((item) => (
                        <li key={item} className="flex items-start gap-2">
                          <span className="w-3.5 h-3.5 flex items-center justify-center text-airdoa-gold mt-0.5 shrink-0">
                            <i className="ri-check-line text-xs" />
                          </span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </dd>
                </div>
              </dl>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
